export const SOLICITUD_ESTADOS = Object.freeze({
  PREAPROBADA: "aceptada",
  PENDIENTE: "pendiente",
  RECHAZADA: "rechazada",
});

export const SOLICITUD_ESTADO_LABELS = Object.freeze({
  [SOLICITUD_ESTADOS.PREAPROBADA]: "Preaprobada",
  [SOLICITUD_ESTADOS.PENDIENTE]: "Pendiente",
  [SOLICITUD_ESTADOS.RECHAZADA]: "Rechazada",
});

export const SOLICITUD_TIPO = Object.freeze({
  PERSONAL: "personal",
});

export const formatSolicitudEstadoLabel = (estado) =>
  SOLICITUD_ESTADO_LABELS[estado] || SOLICITUD_ESTADO_LABELS[SOLICITUD_ESTADOS.PENDIENTE];
